import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Segment,
  Table,
  Grid,
  Header,
  Icon,
  Button,
  Input,
  Message,
  Label,
  Menu,
  Popup,
  Loader
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import orderBy from 'lodash/orderBy'
import constantCase from 'constant-case'

import './Conducts.css'
import ConductsReadCSV from './ConductsReadCSV'
import ConductsApproval from './ConductsApproval'

const _ = { find, groupBy, orderBy}

const changeCase = {
  constantCase: constantCase
}

const ConductsPV = (props) => {
  if (props.auth) {
    const {
      column, direction, section, quarter, error, success, fileName, dirtyInput,
      sectionStudents, sectionSubject, username, areConductsSaved, userId, userType
    } = props;
    if(section.length !== 1) return <Loader active inline='centered' />;
    if(sectionSubject.length !== 1) return <Loader active inline='centered' />;

    const sectionSubjectDetail = _.find(sectionSubject[0].details, {
      quarter: parseInt(quarter),
      type: 'conduct'
    });

    let isDisabled = true;

    if(sectionSubjectDetail.status === 'To Do' || sectionSubjectDetail.status === 'Discarded') {
      if(userType === 'admin' || sectionSubject[0].teacherId === userId) {
        isDisabled = false;
      }
    } else if(sectionSubjectDetail.status === 'Created') {
      if(userType === 'admin' || userType === 'levelHead') {
        isDisabled = false;
      }
    } else {
      if(userType === 'admin' || userType === 'principal' || userType === 'registrar') {
        isDisabled = false;
      }
    }

    const gender = _.groupBy(sectionStudents, o => o.student.gender)
    let currentDataMale = [], currentDataFemale = [];
    if(gender.hasOwnProperty('Male')) {
      currentDataMale = gender['Male'];
    }

    if(gender.hasOwnProperty('Female')) {
      currentDataFemale = gender['Female'];
    }

    const studentsTableMale = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      if (props[changeCase.constantCase(studentName)] === undefined){
        return null;
      }  else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-1`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-1`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-1`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-2`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-2`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-2`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-3`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-3`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-3`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-4`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-4`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-4`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-5`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-5`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-5`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[changeCase.constantCase(studentName)]} </span> :
                  <Input
                    name={changeCase.constantCase(studentName)}
                    size='small'
                    className='grades-input'
                    value={props[changeCase.constantCase(studentName)]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
      if (props[changeCase.constantCase(studentName)] === undefined){
        return null;
      } else {
        return (
          <Table.Row key={key} className='sections-table-row'>
            <Table.Cell>{studentName}</Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-1`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-1`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-1`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-2`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-2`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-2`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-3`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-3`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-3`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-4`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-4`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-4`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='right' collapsing>
              {
                isDisabled ?
                <span> {props[`${changeCase.constantCase(studentName)}-5`]} </span> :
                <Input
                  name={`${changeCase.constantCase(studentName)}-5`}
                  size='small'
                  className='conducts-input-small'
                  value={props[`${changeCase.constantCase(studentName)}-5`]}
                  onChange={props.handleChange}
                />
              }
            </Table.Cell>
            <Table.Cell textAlign='center' collapsing>
              {
                isDisabled ?
                <span> {props[changeCase.constantCase(studentName)]} </span> :
                  <Input
                    name={changeCase.constantCase(studentName)}
                    size='small'
                    className='grades-input'
                    value={props[changeCase.constantCase(studentName)]}
                    onChange={props.handleChange}
                  />
              }
            </Table.Cell>
          </Table.Row>
        );
      }
    });

    const headers = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            textAlign='center'
            sorted={column === 'name' ? direction : null}
            onClick={() => props.handleSort('name')}
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>1</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>2</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>3</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>4</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>5</Table.HeaderCell>
          <Table.HeaderCell textAlign='center'>Total</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    )

    let quarterLabel;
    if (quarter === '1') {
      quarterLabel = '1st Quarter';
    } else if (quarter === '2') {
      quarterLabel = '2nd Quarter';
    } else if (quarter === '3') {
      quarterLabel = '3rd Quarter';
    } else if (quarter === '4') {
      quarterLabel = '4th Quarter';
    } else {
      quarterLabel = 'No Quarter';
    }
    const sortedCreated = _.orderBy(props.created, ['createdDate'], ['asc']);
    const createdTableBody = sortedCreated.map((create, key )=> {
      const subject = _.find(props.subjects, {
        subjectId: create.sectionSubject.subjectId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/conducts/${create.sectionSubject.sectionId}/${create.sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
              {subject.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedChecked = _.orderBy(props.checked, ['checkedDate'], ['asc']);
    const checkedTableBody = sortedChecked.map((check, key )=> {
      const subject = _.find(props.subjects, {
        subjectId: check.sectionSubject.subjectId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/conducts/${check.sectionSubject.sectionId}/${check.sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
              {subject.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });
    const sortedReviewed = _.orderBy(props.reviewed, ['createdDate'], ['asc']);
    const reviewedTableBody = sortedReviewed.map((review, key )=> {
      const subject = _.find(props.subjects, {
        subjectId: review.sectionSubject.subjectId
      });

      return (
        <Table.Row key={key}>
          <Table.Cell>
            <NavLink  to={`/conducts/${review.sectionSubject.sectionId}/${review.sectionSubject.sectionSubjectId}?quarter=${quarter}`}>
              {subject.name}
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });

    return (
      <div>
        <Segment>
          {
            sectionStudents.length === 0 ?
            <Segment placeholder>
              <Header icon>
                <Icon name='database' />
                Populate the {section[0].gradeLevel} - {section[0].name} with students.
              </Header>
              <Button primary>Section Page</Button>
            </Segment> :
            <Grid>
              <Grid.Row className="conducts-title-row" columns={3}>
                <Grid.Column width={6}>
                  <span className="conducts-title">
                    {sectionSubject[0].subject.name}
                  </span>
                  <br/>
                  <span className="conducts-subtitle">
                    {section[0].gradeLevel} - {section[0].name}
                  </span>
                </Grid.Column>
                <Grid.Column width={4}>

                </Grid.Column>
                <Grid.Column width={6} textAlign='right'>
                  <span className="conducts-title">
                    {quarterLabel}
                  </span>
                  <br/>
                  {
                    sectionSubjectDetail.status === 'Approved' ?
                    <Label color='green' horizontal>
                      {sectionSubjectDetail.status}
                    </Label> :
                    <Label color='yellow' horizontal>
                      {sectionSubjectDetail.status}
                    </Label>
                  }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Menu compact>
                    {
                      userType === 'admin' ||  userType === 'levelHead'?
                      <Popup
                        on='click'
                        position='bottom center'
                        trigger={
                          <Menu.Item as='a'>
                            <Icon name='check' /> For Checking
                            <Label color={props.created.length === 0 ? 'green' : 'red'} floating>
                              {props.created.length}
                            </Label>
                          </Menu.Item>
                        }
                        className={props.created.length === 0 ? '' : 'popup-reminders'}
                      >
                      <Table basic='very' size='small'>
                        <Table.Body>
                          {createdTableBody}
                        </Table.Body>
                      </Table>
                      </Popup>: null
                    }
                    {
                      userType === 'admin' ||  userType === 'registrar'?
                      <Popup
                        on='click'
                        position='bottom center'
                        trigger={
                          <Menu.Item as='a'>
                            <Icon name='book' /> For Review
                            <Label color={props.checked.length === 0 ? 'green' : 'red'} floating>
                              {props.checked.length}
                            </Label>
                          </Menu.Item>
                        }
                        className={props.checked.length === 0 ? '' : 'popup-reminders'}
                      >
                      <Table basic='very' size='small'>
                        <Table.Body>
                          {checkedTableBody}
                        </Table.Body>
                      </Table>
                      </Popup>: null
                    }
                    {
                      userType === 'admin' ||  userType === 'principal'?
                      <Popup
                        on='click'
                        position='bottom center'
                        trigger={
                          <Menu.Item as='a'>
                            <Icon name='thumbs up' /> For Approval
                            <Label color={props.reviewed.length === 0 ? 'green' : 'red'} floating>
                              {props.reviewed.length}
                            </Label>
                          </Menu.Item>
                        }
                        className={props.reviewed.length === 0 ? '' : 'popup-reminders'}
                      >
                      <Table basic='very' size='small'>
                        <Table.Body>
                          {reviewedTableBody}
                        </Table.Body>
                      </Table>
                      </Popup>: null
                    }
                  </Menu>
                  <br /> <br />
                  <span>
                    <strong>1</strong> - <em>Responsibility and Showing Concern for Others</em> (5 pts)<br/>
                    <strong>2</strong> - <em>Courtesy/ Integrity</em> (5 pts)<br/>
                    <strong>3</strong> - <em>Virtual Classroom Discipline</em> (5 pts)<br/>
                    <strong>4</strong> - <em>Group Skills</em> (5 pts)<br/>
                    <strong>5</strong> - <em>Punctuality and Regularity</em> (5 pts)
                  </span>
                </Grid.Column>
                <Grid.Column width={8}>
                  {
                    areConductsSaved &&
                    <ConductsApproval
                      username={username}
                      fileName={fileName}
                      userType={userType}
                      sectionCode={sectionSubject[0].subject.code}
                      sectionSubjectDetail={sectionSubjectDetail}
                      open={props.open}
                      handleApprovalOpen={props.handleApprovalOpen}
                      handleApprovalClose={props.handleApprovalClose}
                      handleUploadFileChange={props.handleUploadFileChange}
                      handleUpdateSectionSubjectDetails={props.handleUpdateSectionSubjectDetails}
                    />
                  }
                  <Button.Group floated='right'>
                    <Button
                      color='green'
                      onClick={props.handleSubmit}
                      icon labelPosition='left'
                    ><Icon name='save' />
                      Save Conducts
                    </Button>
                    <Button.Or />
                    <ConductsReadCSV
                      handleFileChange={props.handleFileChange}
                      handleDataSave={props.handleDataSave}
                    />
                  </Button.Group>
                </Grid.Column>
              </Grid.Row>
              {
                error ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      error
                      header='Conduct Error'
                      content='Conducts must be between 1 and 25.'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                success ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      positive
                      header='Conducts successfully saved!'
                      content='Upload supporting files and add notes to proceed.'
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                dirtyInput ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header='Some changes were made.'
                      content="Please save."
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              {
                sectionSubjectDetail.status === 'Discarded' ?
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Message
                      warning
                      header={`Your submission was discarded by ${sectionSubjectDetail.discardBy}`}
                      content={sectionSubjectDetail.discardNotes}
                    />
                  </Grid.Column>
                </Grid.Row> :
                null
              }
              <Grid.Row>
                <Grid.Column width={8}>
                  <h4>Male</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableMale}</Table.Body>

                  </Table>
                </Grid.Column>
                <Grid.Column width={8}>
                  <h4>Female</h4>
                  <Table celled selectable sortable striped compact size='small'>
                    {headers}

                    <Table.Body>{studentsTableFemale}</Table.Body>

                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          }

        </Segment>
      </div>
    )
  } else {
    return <Redirect to='/' />
  }

}

export default ConductsPV;
